import { defaultShippingOptionIndex } from '../consts';

/**
 * @description Util for get/set default shipping option
 * @attention If you omit defaultSelectedOptionId, google will be choose first item by default.
 */
export const getDefaultShippingOption = (shippingOptions: google.payments.api.SelectionOption[]) =>
  shippingOptions[defaultShippingOptionIndex];
